// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"StarRate_wrapper__zn7dz","star":"StarRate_star__X9fg4"};